<template>
  <!-- <div> -->
    <CFooter :fixed="false">
      <div>
        <a href="#" target="_blank">EV Survey</a>
        <span class="ml-1">&copy; {{new Date().getFullYear()}}</span>
      </div>
      <div class="mfs-auto">
        <span class="mr-1" target="_blank">Powered by</span>
        <a href="https://vuejs.org">Vue</a>
      </div>
    </CFooter>
  <!-- </div> -->
</template>

<script>
export default {
  name: 'TheFooter'
}
</script>
